import { NgStyle } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  imports: [NgStyle],
  selector: 'ideals-skeleton',
  styleUrl: './skeleton.component.scss',
  templateUrl: './skeleton.component.html',
})
export class SkeletonComponent {
  readonly height = input('16px');
  readonly styleClass = input<string>();
  readonly width = input('100%');

  protected readonly containerStyle = computed(() => ({ width: this.width(), height: this.height() }));
}
